import Hero from "../components/Hero";
import About from "../components/About";
import Involvement from "../components/Involvement";
import Experience from "../components/Experience";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Involvement />
      <Experience />
      <Footer />
    </>
  );
}

export default Home;

